import type { Job } from "@coinfallsmp/shared";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listJobs } from "../api.js";

export default function Jobs() {
  const [jobs, setJobs] = useState<Job[]>([]);
  const [loading, setLoading] = useState(true);

  async function refresh() {
    setLoading(true);
    try {
      const res = await listJobs();
      setJobs(res.items);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    refresh();
    const interval = setInterval(refresh, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section>
      <div className="page-header">
        <h1>Jobs</h1>
        <button className="button secondary" onClick={refresh} disabled={loading}>
          Refresh
        </button>
      </div>
      <table className="video-table">
        <thead>
          <tr>
            <th>Type</th>
            <th>Status</th>
            <th>Progress</th>
            <th>Video</th>
            <th>Updated</th>
          </tr>
        </thead>
        <tbody>
          {jobs.map((job) => (
            <tr key={job.id}>
              <td>{job.type}</td>
              <td>
                <span className={`status-badge status-${job.status}`}>
                  {job.status}
                </span>
              </td>
              <td>{job.progressPct}%</td>
              <td>
                {job.videoId ? (
                  <Link to={`/videos/${job.videoId}`}>{job.videoId}</Link>
                ) : (
                  "—"
                )}
              </td>
              <td>{new Date(job.updatedAt).toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {latestFailureNote(jobs)}
    </section>
  );
}

function latestFailureNote(jobs: Job[]) {
  const failed = jobs.find((j) => j.status === "failed" && j.errorMessage);
  if (!failed) return null;
  return (
    <p className="form-error">
      Most recent failure ({failed.id.slice(0, 8)}): {failed.errorMessage}
    </p>
  );
}
